import React, { useImperativeHandle, useState, forwardRef } from 'react'
import ReactDOM from 'react-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'

export const createAPI = (Component, options) => {
    const config = {
        visible: false,
        destroyOnClose: true,
        ...(options || {})
    }

    let $root = document.createElement('div')

    if (typeof config.getCustomContainer === 'function') {
        const $element = config.getCustomContainer()
        $element?.appendChild($root)
    } else {
        document.body.appendChild($root)
    }

    let currentConfig = {
        ...config,
        visible: true,
        onCancel(props) {
            close()

            config.onCancel && config.onCancel(props)
        }
    }

    function render(props) {
        ReactDOM.render(
            <ConfigProvider locale={zhCN}>
                <Component {...props} />
            </ConfigProvider>,
            $root
        )
    }

    function destroy(...args) {
        const unmountResult = ReactDOM.unmountComponentAtNode($root)
        if (unmountResult && $root.parentNode) {
            $root.parentNode.removeChild($root)
        }

        const triggerCancel = args.some(param => param && param.triggerCancel)
        if (currentConfig.onCancel && triggerCancel) {
            currentConfig.onCancel(...args)
        }
    }

    function update(newConfig) {
        currentConfig = {
            ...currentConfig,
            ...(newConfig || {})
        }

        render(currentConfig)
    }

    function close(...args) {
        const { afterClose } = currentConfig

        currentConfig = {
            ...currentConfig,
            visible: false,
            afterClose() {
                destroy.call(this, ...args) // 注意：需要把afterClose属性记载Modal上

                afterClose && afterClose()
            }
        }

        render(currentConfig)
    }

    render(currentConfig)

    return {
        update,
        close,
        destroy
    }
}

export const refAPI = (Component, config = {}) => {
    return forwardRef((_, ref) => {
        const [ctrl, setCtrl] = useState({
            visible: false
        })

        useImperativeHandle(ref, () => ({
            setCtrl
        }))

        const props = {
            ...ctrl,
            onCancel() {
                setCtrl(prev => ({
                    ...prev,
                    visible: false
                }))
            }
        }

        return <Component {...config} {...props} />
    })
}
